function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#3fd2c7",
      fillOpacity: 1
    },
    d: "M 0 26.472656 L 30 26.472656 L 30 3.53125 L 0 3.53125 Z M 1.765625 5.886719 L 1.765625 5.296875 L 28.234375 5.296875 L 28.234375 5.886719 L 15 17.363281 Z M 28.234375 8.222656 L 28.234375 23.074219 L 22.75 16.214844 L 21.367188 17.316406 L 27.28125 24.707031 L 2.71875 24.707031 L 8.632812 17.316406 L 7.25 16.214844 L 1.765625 23.074219 L 1.765625 8.222656 L 15 19.699219 Z M 28.234375 8.222656 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMail);
export default __webpack_public_path__ + "static/media/send_mail.527b2e0f2c0acce7607456df498e6164.svg";
export { ForwardRef as ReactComponent };